import moment from 'moment';

export const formatHistoryDate = (date)=>
    new Intl.DateTimeFormat('en-GB', { dateStyle: 'short', timeStyle: 'short' }).format(date);


export const formatHistoryDateVerbose = (date)=>
    new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    }).format(date);

export const formatCreationDate = (date)=>
    moment(date).format('MMM D, YYYY');

export const formatEventDate = (date)=>
    moment.utc(date).format('dddd, MMMM Do YYYY, h:mm a');

// Event times are UTC. Firebase stores "YYYY-MM-DD HH:mm:ss", while the
// datetime-local inputs use "YYYY-MM-DDTHH:mm". Older events were saved in the
// input format, so parsing accepts both.
const parseEventTime = (value) =>
    moment.utc(value, [moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss'], true);

export const toFirebaseEventTime = (value) => {
    const time = parseEventTime(value);
    return time.isValid() ? time.format('YYYY-MM-DD HH:mm:ss') : value;
};

export const toInputEventTime = (value) => {
    const time = parseEventTime(value);
    return time.isValid() ? time.format('YYYY-MM-DDTHH:mm') : value;
};
